// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"5a657e2b","509":"a97da312","579":"60be7e83"}[chunkId] + ".chunk.css";
};